<template lang="pug">
.dados-relatorio-rastreabilidade-shared
    h2.section-title.pb-1 {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportData') }}
    .row.m-0
        .dados-relatorio-form
            el-form(ref="dadosRelatorioForm", :model="dadosRelatorio", :inline="true", label-position="top", class="form-alignment")
                .numero-relatorio
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportNumber') }}
                        span.required *
                    el-form-item(prop="reportNumber", :rules="reportNumberRules")
                        el-input(
                            v-model='dadosRelatorio.reportNumber',
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportNumber')"
                            type='number'
                            maxlength='250'
                        )

                .cultura
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.crop') }}
                        span.required *
                    el-form-item(prop="culture", :rules="cultureRules")
                        el-select(
                            v-model='dadosRelatorio.culture',
                            :placeholder="$t('mensagens.comuns.selecione')",
                            value-key='id',
                            class="custom-select-cultura"
                            disabled
                        )
                            el-option(
                                v-for='cultura in culturas',
                                :key='cultura.id',
                                :value='cultura',
                                :label='cultura.nome'
                            ) {{ cultura.nome }}

                .volume
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume') }}
                        span.required *
                    el-form-item(prop="reportVolume", :rules="reportVolumeRules")
                        el-input(
                            v-model='dadosRelatorio.reportVolume',
                            :placeholder="$t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.volume')",
                            type='number',
                            @input='emitVolume'
                        )

                .data-relatorio
                    .d-flex
                        span(class="mb-1 dados-relatorio-subtitle") {{ $t('relatorio_rastreabilidade.messages.traceabilityReport.reportData.reportDate') }}
                        span.required *
                    el-form-item(prop="reportDate", :rules="reportDateRules")
                        el-date-picker(
                            v-model='dadosRelatorio.reportDate',
                            class='custom-date-picker',
                            type='date',
                            placeholder='Selecione',
                            format='dd/MM/yyyy',
                        )
</template>

<script>
import EventBus from '@/utils/eventBus';
import RelatorioRastreabilidadeService from '@/services/RelatorioRastreabilidadeService';
import culturaService from '@/services/CulturaService';

export default {
    name: 'ReportDataDefault',
    data() {
        return {
            totalizerValues: [],
            volumeDisponivel: null,
            dadosRelatorio: {
                reportNumber: null,
                culture: null,
                reportVolume: null,
                reportDate: null
            },
            culturas: [],
            errors: {
                reportNumber: false,
                culture: false,
                reportVolume: false,
                reportDate: false
            },
            formValid: false,
            requiredField: this.$t('relatorio_rastreabilidade.messages.common.validation.requiredField')
        };
    },
    computed: {
        reportNumberRules() {
            return [{ required: true, message: this.requiredField, trigger: 'change' }];
        },
        cultureRules() {
            return [{ required: true, message: this.requiredField, trigger: 'change' }];
        },
        reportVolumeRules() {
            return [
                { required: true, message: this.requiredField, trigger: 'change' },
                { validator: this.validarVolume, trigger: 'change' }
            ];
        },
        reportDateRules() {
            return [{ required: true, message: this.requiredField, trigger: 'change' }];
        }
    },
    watch: {
        dadosRelatorio: {
            handler(newVal) {
                EventBus.$emit('report-valid-data', newVal);
            },
            deep: true
        }
    },
    async mounted() {
        EventBus.$on('totalizer-updated', this.passDataToContractList);
        const params = this.$route.params;
        const response = await RelatorioRastreabilidadeService.findById(params.id);
        response.data.reportDate = this.validarDataRelatorio(response.data.reportDate);
        this.dadosRelatorio = response.data;
        this.buscaCulturas();
        this.emitVolume();
        EventBus.$emit('contratos-carregados', this.dadosRelatorio.totalContractsVolume);
    },
    methods: {
        passDataToContractList(data) {
            this.totalizerValues = data;
            this.volumeDisponivel = data[1];
        },
        emitVolume() {
            if (this.dadosRelatorio.reportVolume < 0) {
                this.dadosRelatorio.reportVolume = 0;
            }

            if (this.dadosRelatorio.reportVolume.length > 18) {
                this.dadosRelatorio.reportVolume = this.dadosRelatorio.reportVolume.slice(0, 18);
            }
            EventBus.$emit('volume-input-updated', this.dadosRelatorio.reportVolume);
        },
        async buscaCulturas() {
            await culturaService.findCultura().then(({ data }) => {
                const soja = data.find(cultura => cultura.nome.toLowerCase() === 'soja');
                if (soja) {
                    this.dadosRelatorio.culture = soja;
                }
                this.culturas = data;
            });
        },
        validarVolume(rule, value, callback) {
            setTimeout(() => {
                if (value > this.volumeDisponivel) {
                    const message = this.$t('relatorio_rastreabilidade.messages.common.validation.availableVolume');
                    callback(new Error(message));
                } else {
                    callback();
                }
            }, 200);
        },
        validarFormulario() {
            this.$refs.dadosRelatorioForm.validate(valid => {
                if (!valid) {
                    this.formValid = false;
                } else {
                    this.formValid = true;
                }
            });
        },
        validarDataRelatorio(reportDate) {
            return reportDate === '1970-01-01T00:00:00' ? null : reportDate;
        }
    }
};
</script>

<style lang="scss" scoped>
.dados-relatorio-rastreabilidade-shared {
    margin-top: 15px;
}
.dados-relatorio-title {
    font-size: 16px;
    font-weight: 500;
}
.dados-relatorio-subtitle {
    font-size: 14px;
    font-weight: 400;
}
.dados-relatorio-form {
    width: 100%;
    background-color: var(--white);
    border-radius: 6px;
    padding: 15px;
}
.section-title {
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    color: var(--primary-font-color);
}
.form-alignment {
    display: flex;

    .required {
        margin-left: 2px;
        color: var(--red)
    }
    .numero-relatorio {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .volume {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .cultura {
        display: flex;
        flex-direction: column;
        width: 25%;
        margin-right: 10px;
    }
    .data-relatorio {
        display: flex;
        flex-direction: column;
        width: 25%;
    }

    .custom-select-cultura {
        width: 100%;
    }
    .custom-date-picker {
        width: 100% !important;
    }
}

.is-invalid {
    border-color: var(--red);
}
.text-danger {
    color: var(--red);
    font-size: 12px;
}
</style>
